export { default } from './SkeletonLoader';
